<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'UserControl'
};
</script>

<style lang="less" scoped></style>